import { atom } from "jotai";
import { focusAtom } from "jotai-optics";

import { HoleCount } from "@whoosh/design-system/src/components/icons_v2/courseLayout/icons/HoleCountIcon";

export type CourseAvailabilityQueryInput = {
  holeCount?: HoleCount;
  timeRange?: { timeGTE?: string; timeLTE?: string };
  groupSize?: number;
};

export const courseAvailabilityQueryInputAtom =
  atom<CourseAvailabilityQueryInput>({});

export const courseAvailabilityQueryInput_holeCount = focusAtom(
  courseAvailabilityQueryInputAtom,
  (o) => o.prop("holeCount")
);

export const courseAvailabilityQueryInput_timeRange = focusAtom(
  courseAvailabilityQueryInputAtom,
  (o) => o.prop("timeRange")
);

export const courseAvailabilityQueryInput_groupSize = focusAtom(
  courseAvailabilityQueryInputAtom,
  (o) => o.prop("groupSize")
);
